// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting-icon-position[data-v-f6db9c68]{top:12px;right:12px;z-index:12}.config-container[data-v-f6db9c68]{-webkit-transition:all .3s ease;transition:all .3s ease}.config-container.hide[data-v-f6db9c68]{max-height:0;overflow:hidden;border:none!important}.config-container.show[data-v-f6db9c68]{max-height:400px}", ""]);
// Exports
module.exports = exports;
